import { useEffect } from 'react'

/**
 * Hard-navigate into the staff admin SPA (gateway owns /admin/*).
 * Same-origin reload of the current path so proxies serve the staff SPA
 * without painting mangosteen Admin chrome.
 *
 * Do not prefix VITE_STAFF_ADMIN_URL onto pathname — values like `/admin/`
 * would produce `/admin//admin/...`.
 */
export default function StaffAdminRedirect() {
  useEffect(() => {
    const { pathname, search, hash } = window.location
    window.location.replace(`${pathname}${search}${hash}`)
  }, [])
  return null
}
